import React, { useContext, useEffect, useState } from 'react'
import { Button, TextField } from 'monday-ui-react-core'
import { isValidEmail } from 'utils/commonUtils'
import { AuthSessionContext } from 'api/AuthSession'
import { toast } from 'react-toastify'

const ForgotPasswordForm = () => {
    const { sendCode, resetPassword, setShowToast } =
        useContext(AuthSessionContext)
    const [code, setCode] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [errorMessage, setErrorMessage] = useState(undefined)
    const [disable, setDisable] = useState(true)
    const [stage, setStage] = useState(1) // 1 = email stage, 2 = code stage

    const notify = () => {
        toast.success('Your password has been updated', {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: 'toastify__toast--success-custom',
            bodyClassName: 'toastify-body',
            progressClassName: 'toastify-progress-bar',
        })
    }

    const onSubmitSendCode = async (event) => {
        event.preventDefault()

        try {
            await sendCode(email)
            setStage(2)
            setDisable(true)
        } catch (error) {
            setErrorMessage(error.message)
        }
    }

    const onSubmitResetPassword = async (event) => {
        event.preventDefault()

        if (password !== confirmPassword) {
            setErrorMessage('Passwords must match')
            return
        }

        try {
            await resetPassword(code, password, email)
            notify()
        } catch (error) {
            console.log(error)
            setErrorMessage(error.message)
        }
    }

    const validateFields = () => {
        if (!isValidEmail(email) && email.length) {
            return true
        }
        if (!!errorMessage) {
            return true
        } else {
            return false
        }
    }

    useEffect(() => {
        if (isValidEmail(email)) {
            setDisable(false)
        } else {
            setDisable(true)
        }
    }, [email])

    useEffect(() => {

        if (confirmPassword.length >= 8 && password.length >= 8 && code.length) {
            if (password !== confirmPassword) {
                setDisable(true)
                setErrorMessage("Passwords must match")
            } else {
                setDisable(false)
                setErrorMessage("")
            }
        }
    }, [code, password, confirmPassword])

    return (
        <div className="form-content">
            <h1>Forgot your password?</h1>
            {stage === 1 && (
                <>
                    <p>
                        Enter your Email below and we will send a message to
                        reset your password.
                    </p>
                    <form onSubmit={onSubmitSendCode}>
                        <TextField
                            id="email"
                            value={email}
                            onChange={(event) => setEmail(event)}
                            title="Email"
                            placeholder="Enter your email"
                            size={TextField.sizes.MEDIUM}
                            validation={{
                                status: validateFields() ? 'error' : '',
                                text:
                                    !isValidEmail(email) && email.length
                                        ? 'Please enter a valid email address.'
                                        : '',
                            }}
                            maxLength={320}
                        />
                        {errorMessage ? (
                            <p className="mt-3 text-center error-message">
                                {errorMessage}
                            </p>
                        ) : null}
                        <Button
                            size={Button.sizes.LARGE}
                            disabled={disable}
                            type={Button.types.SUBMIT}
                            className="mt-3"
                        >
                            Reset my password
                        </Button>
                    </form>
                </>
            )}
            {stage === 2 && (
                <>
                    <p>
                        We have sent a password reset code to your email, enter
                        it below to reset your password.
                    </p>
                    <form onSubmit={onSubmitResetPassword}>
                        <TextField
                            id="code"
                            value={code}
                            onChange={(event) => setCode(event.trim())}
                            title="Code"
                            placeholder="Enter your code"
                            size={TextField.sizes.MEDIUM}
                            maxLength={12}
                        />
                        <div className="mt-3 mb-2">
                            <TextField
                                id="password"
                                value={password}
                                onChange={(event) => setPassword(event)}
                                wrapperClassName="input-component__icon_visibility"
                                title="New Password"
                                placeholder="Enter your new password"
                                size={TextField.sizes.MEDIUM}
                                type={TextField.types.PASSWORD}
                                validation={{
                                    status: !!errorMessage ? 'error' : '',
                                }}
                                maxLength={99}
                                minLength={8}
                            />
                        </div>

                        <div className="mt-3 mb-2">
                            <TextField
                                id="confirm-password"
                                value={confirmPassword}
                                onChange={(event) => setConfirmPassword(event)}
                                wrapperClassName="input-component__icon_visibility"
                                title="Enter New Password Again"
                                placeholder="Enter your new password again"
                                size={TextField.sizes.MEDIUM}
                                type={TextField.types.PASSWORD}
                                validation={{
                                    status: !!errorMessage ? 'error' : '',
                                }}
                                maxLength={99}
                                minLength={8}
                            />
                            {errorMessage ? (
                                <p className="mt-3 text-center error-message">
                                    {errorMessage}
                                </p>
                            ) : null}
                        </div>
                        <section className='requirements-list pt-2'>
                            <ul>
                                <li>Password must contain at least 8 characters</li>
                                <li>Password must contain an upper case letter</li>
                                <li>Password must contain a lower case letter</li>
                                <li>Password must contain a number</li>
                                <li>Password must contain a special character or a space</li>
                                <li>Password must not contain a leading or trailing space</li>
                                <li>Passwords must match</li>
                            </ul>
                        </section>
                        <Button
                            size={Button.sizes.LARGE}
                            disabled={disable}
                            type={Button.types.SUBMIT}
                        >
                            Change Password
                        </Button>
                    </form>
                </>
            )}
        </div>
    )
}

export default ForgotPasswordForm
